import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../Global/Dropdowns/Dropdown';
import UserCard from '../Global/Teasers/UserCard';
import UserAvatar from '../Global/Avatars/UserAvatar';
import IconWithText from '../Global/Icons/IconWithText';
import ShareDropdown from '../Global/Sharing/ShareDropdown';
import singleOrMultiple from '../../utils/singleOrMultiple';
import contentTypeName from '../../utils/contentTypeName';
import { capitalizeFirstLetter } from '../../utils/stringConversion';

const DrillHeader = ({ content, commentCount, doIFollow, onFollowClick, loggedInUser }) => {
  const readableContentType = contentTypeName(content.type);
  let writtenByText;
  switch (content.type) {
    case 'session':
    case 'pitchdiagram':
      writtenByText = `${capitalizeFirstLetter(readableContentType)} created by`;
      break;
    default:
      writtenByText = 'Written by';
  }

  const commentString = singleOrMultiple('comment', commentCount);
  const numberOfCommentsString = `${commentCount} ${commentString}`;

  return (
    <div className="content-meta">
      {content.author &&
        <div className="author">
          <UserAvatar image={content.author.image_url} verified={content.author.the_real_deal} />

          <div className="author-details">
            <div className="author-name">
              <span className="written-by">{writtenByText}</span>
              <Dropdown size="s" label={content.author.full_name}>
                <UserCard user={content.author} doIFollow={doIFollow} onFollowClick={onFollowClick} loggedInUser={loggedInUser} />
              </Dropdown>
            </div>

            <p className="publish-date text-grey">{content.date_readable}</p>
          </div>
        </div>
      }

      <div className="content-meta-right">
        {commentCount !== undefined &&
          <a href="#comments-anchor" className="comments-anchor-link">
            <IconWithText name="comment" size="m" fill="green">{numberOfCommentsString}</IconWithText>
          </a>
        }

        <ShareDropdown title={content.title} />
      </div>
    </div>
  );
};

DrillHeader.propTypes = {
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  commentCount: PropTypes.number,
  doIFollow: PropTypes.array,
  onFollowClick: PropTypes.func,
  loggedInUser: PropTypes.object,
};

export default DrillHeader;



// WEBPACK FOOTER //
// ./library/app/components/Drill/DrillHeader.js